export const CONSENT_ACCESS_CMS_PILOT = 'CONSENT_ACCESS_CMS_PILOT' as const;
export const CONSENT_CARE_FOR_HEART = 'CONSENT_CARE_FOR_HEART' as const;
export const CONSENT_ACCESS_LABS_COMPLETED = 'CONSENT_ACCESS_LABS_COMPLETED' as const;

export type ConsentUserMetadataType =
  | typeof CONSENT_ACCESS_CMS_PILOT
  | typeof CONSENT_CARE_FOR_HEART
  | typeof CONSENT_ACCESS_LABS_COMPLETED;
